var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SiteHeaderLayout } from './site-header-layout';
import { Loader } from '../elements/loader';
var cls = classNames('site-loading-layout');
export var SiteLoadingLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    height: calc(90vh - 80px);\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    height: calc(90vh - 80px);\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SiteLoadingLayout',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var SiteLoadingLayout = function (props) {
  var componentProps = useComponentProps(My.NAME, SiteLoadingLayoutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(SiteHeaderLayout, null), React.createElement(My.Body, null, React.createElement(Loader, {
    spinnerSize: 24
  })));
};
SiteLoadingLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;